import { createFileRoute } from "@tanstack/react-router";
import { PageHero } from "@/components/PageHero";
import { img } from "@/lib/images";
import { canonicalLinks, routeMeta } from "@/lib/seo";

export const Route = createFileRoute("/terms")({
  head: () => ({
    meta: [
      ...routeMeta("/terms"),
      { title: "Terms & Conditions | CCOB And Company PA" },
      { name: "description", content: "Terms and conditions governing services provided by CCOB And Company PA in Winter Garden, FL." },
      { property: "og:title", content: "Terms & Conditions" },
      { property: "og:description", content: "Service terms for CCOB And Company PA." },
    ],
    links: canonicalLinks("/terms"),
  }),
  component: TermsPage,
});

function TermsPage() {
  return (
    <>
      <PageHero eyebrow="Legal" title="Terms & Conditions" subtitle="Please review the terms governing our CPA engagements and website use." image={img.heroTerms} />
      <section className="py-24">
        <div className="container-x max-w-3xl prose prose-neutral">
          <p className="text-muted-foreground">Last updated: January 2025</p>
          {[
            ["1. Engagement", "Services provided by CCOB And Company PA are governed by an engagement letter signed prior to commencement. The scope, fees, deliverables, and timing are defined in that letter."],
            ["2. Deposits & Payments", "Some services — including tax preparation and IRS representation — require a deposit prior to work beginning. Invoices are due upon receipt unless otherwise agreed."],
            ["3. Confidentiality", "All client information is held in strict confidence in accordance with AICPA professional standards and applicable Florida law."],
            ["4. Limitations of Liability", "Our liability for any claim arising out of services rendered shall not exceed the fees paid for the specific engagement giving rise to the claim."],
            ["5. Communications", "Email is not a secure communication channel. Sensitive documents should be exchanged through our secure portal whenever possible."],
            ["6. Website Use", "Content on this website is provided for general information only and does not constitute professional advice. Please contact us for guidance specific to your situation."],
            ["7. Governing Law", "These terms are governed by the laws of the State of Florida. Any disputes shall be resolved in the courts of Orange County, Florida."],
            ["8. Contact", "Questions about these terms? Use our secure contact form or call (407) 654-3822."],
          ].map(([t, b]) => (
            <div key={t} className="mt-8">
              <h2 className="font-display text-2xl text-primary">{t}</h2>
              <p className="mt-3 text-muted-foreground leading-relaxed">{b}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
